// extracted by mini-css-extract-plugin
export default {"selectInput":"selectInput_styles_selectInput__QmTrx"};